module.exports = kolibriGlobal.coreVue.components.GenderSelect;